import React from 'react';
import CustomerExperiencePage from '../../features/customer-experience/pages/CustomerExperiencePage';

const AdminCustomerExperience = () => <CustomerExperiencePage />;

export default AdminCustomerExperience;


